import { CheckCircle2, FileEdit, LayoutList } from 'lucide-react';
import { KpiCard } from '@/features/mro-dashboard/components/KpiCard';
import type { QuotationStats } from '../types/quotation.types';

interface QuotationKpiRowProps {
  stats: QuotationStats | null;
  isLoading?: boolean;
}

export function QuotationKpiRow({ stats, isLoading }: QuotationKpiRowProps) {
  const show = (n: number) => (isLoading && !stats ? '—' : n.toString());

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      <KpiCard
        title="All Quotations"
        value={show(stats?.total ?? 0)}
        subtitle="Drafts + submitted"
        icon={LayoutList}
      />
      <KpiCard
        title="Drafts"
        value={show(stats?.draft ?? 0)}
        subtitle="In progress, not yet submitted"
        icon={FileEdit}
      />
      <KpiCard
        title="Submitted"
        value={show(stats?.submitted ?? 0)}
        subtitle="Posted to NetSuite as Cutting Lists"
        icon={CheckCircle2}
      />
    </div>
  );
}
